//@ts-check
import React, { useState } from 'react';
import cx from 'classnames';
import { ConfirmationModal } from '../../_shared';
import EditIcon from '../../_shared/Icon/EditIcon';
import BinIcon from '../../_shared/Icon/BinIcon';
import { FolderWorkflowConfigRowEdit } from './FolderWorkflowConfigRowEdit';

const FolderWorkflowConfigRow = ({
    config,
    workflows,
    onUpdate,
    onDelete,
    isEditing,
    onEditStart,
    onEditCancel,
    hasEditingConfig
}) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleEditStart = () => {
        onEditStart(config);
    };



    const handleDeleteClick = () => {
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        setShowDeleteModal(false);
        await onDelete(config);
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
    };

    if (isEditing) {
        return (
            <FolderWorkflowConfigRowEdit
                config={config}
                workflows={workflows}
                onUpdate={onUpdate}
                onEditCancel={onEditCancel}
            />
        );
    }

    return (
        <>
            <div className={cx('folder-workflow-table__row', {
                'authorization-disabled': hasEditingConfig && !isEditing
            })}>
                <div className="folder-workflow-table__cell folder-workflow-table__cell--icon folder-workflow-table__cell--actions">
                    <a
                        className="folder-workflow-icon-btn"
                        title="Edit"
                        onClick={handleEditStart}>
                        <EditIcon width={16} height={16} />
                    </a>
                    <a
                        className="folder-workflow-icon-btn"
                        title="Delete"
                        onClick={handleDeleteClick}>
                        <BinIcon width={16} height={16} />
                    </a>
                </div>
                <div className="folder-workflow-table__cell">
                    {config.directoryName}
                </div>
                <div className="folder-workflow-table__cell">
                    {config.workflowName}
                </div>
                <div className="folder-workflow-table__cell">
                    {config.workflowStatusName}
                </div>
            </div>

            

            {showDeleteModal && (
                <ConfirmationModal
                    show
                    onHide={handleDeleteCancel}
                    onPrimaryClick={handleDeleteConfirm}
                    onSecondaryClick={handleDeleteCancel}
                    primaryButtonText="Yes"
                    secondaryButtonText="No"
                    title="Remove Folder Workflow"
                    bodyText={`Are you sure you want to remove the workflow configuration for "${config.directoryName}"?`}
                />
            )}
        </>
    );
};

export { FolderWorkflowConfigRow };
